import { useQuery } from "react-query";
import { getAllMappedSnowflakesCount } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetAllMappedSnowflakes = () => {
  return useQuery(
    ["getMappedSnowFlakes"],
    () => getAllMappedSnowflakesCount(),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllMappedSnowflakes;
